import { TimeZoneDetails } from '@tableau/self-service-schedules';
import { SiteUrls } from '@tableau/shared-urls';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { ExtractTaskType } from '~src/extractTask/serverApi/types/IExtractTask';
import { PublishedConnectionExtractRefreshLevel } from '~src/publishedConnection/types/PublishedConnectionExtractRefreshLevel';
import { ExtractServiceRefreshType } from '~src/schedule/serverApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

export function getPublishedConnectionExtractRefreshLevel(extractTransactionLevel?: string): PublishedConnectionExtractRefreshLevel {
  if (extractTransactionLevel && extractTransactionLevel.toLocaleLowerCase() === 'table') {
    return PublishedConnectionExtractRefreshLevel.Table;
  }
  return PublishedConnectionExtractRefreshLevel.Database;
}

export function getPublishedConnectionExtractRefreshType(extractTransactionType?: string): ExtractServiceRefreshType {
  if (extractTransactionType && extractTransactionType === 'ExtractServiceIncrement') {
    return ExtractTaskType.ExtractServiceIncrement as ExtractServiceRefreshType;
  }
  return ExtractTaskType.ExtractServiceFullRefresh as ExtractServiceRefreshType;
}

export function isExtractSSSEnabled(): boolean {
  const isExtractSSSEnabledForServer = FeatureFlags.selfServiceSchedulesForRefreshEnabled;
  const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
  return isExtractSSSEnabledForServer && isExtractSSSEnabledForSite;
}

export function getUserTimeZoneDetails(): TimeZoneDetails {
  const server = getSessionManagementServiceInstance();
  const userAccountSettingsLink = new SiteUrls({
    siteUrlName: server.sessionSiteUrlName(),
    queryString: window.location.search
  }).userSettingsUrl(server.sessionUserInfo().username, server.sessionUserInfo().domainName);
  return {
    timeZonesEnabled: true,
    timeZoneDisplayName: server.userTimeZone().displayName,
    linkToUserSettings: userAccountSettingsLink,
  };
}
